import { render, staticRenderFns } from "./CookieItem.vue?vue&type=template&id=163db431"
import script from "./CookieItem.vue?vue&type=script&lang=js"
export * from "./CookieItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports